import Repository from "./Repository";

import authHeader from "@/services/auth-header"; 

const resource = "/special-projects";

export default {
    list(page = 1, perPage= null, search = "", sort = "", direction = "", filters = []) {
        let url = `${resource}?page=${page}`;
        if (sort) url += `&sort=${sort}`;
        if (direction) url += `&sortDirection=${direction}`;
        if (filters.length) url += "&filters=" + JSON.stringify(filters);
        if (search) url += `&search=${search}`;
        if (perPage) url += `&perPage=${perPage}`;
      return Repository.get(url,{ headers: authHeader()});
    },
    store(data) {
      return Repository.post(`${resource}`, data,{ headers: authHeader()});
    },
    delete(id) {
      return Repository.delete(`${resource}/${id}`,{ headers: authHeader()});
    },
    show(id) {
        return Repository.get(`${resource}/${id}`,{ headers: authHeader()});
    },
    update(id, data) {
        return Repository.put(`${resource}/${id}`, data,{ headers: authHeader()});
    }
};
